import type { ItemStatus, ClaimStatus } from '../types';

export const ITEM_STATUS_LABELS: Record<ItemStatus, string> = {
  available: 'Opbevaret',
  returned: 'Udleveret',
  discarded: 'Kasseret',
};

export const ITEM_STATUS_COLORS: Record<ItemStatus, string> = {
  available: 'green',
  returned: 'blue',
  discarded: 'red',
};

export const CLAIM_STATUS_LABELS: Record<ClaimStatus, string> = {
  open: 'Åben',
  matched: 'Matchet',
  closed: 'Lukket',
};

export const CLAIM_STATUS_COLORS: Record<ClaimStatus, string> = {
  open: 'orange',
  matched: 'green',
  closed: 'gray',
};
